export default "__VITE_ASSET__DDhmPpyK__$_?component__"